<template>
  <div class="covid-consent-cont-table-plus">
    <div style="text-align:center; display:flex; width:100%;">
      <div style="padding-right: 20px; padding-top: 10px;">🚨</div>
      <div style="flex: 1;">
        To help you schedule meetings remotely, we are offering
        <strong>all paid features 100% FREE</strong>
        exclusively for use during the COVID-19 crisis.
      </div>
      <div style="padding-left: 20px; padding-top: 10px;">🚨</div>
    </div>
    <table>
      <tr>
        <td></td>
        <td>Free forever</td>
        <td>Plus &amp; Pro plans</td>
        <td>
          Stronger, Together! Plan
          <div
            style="background-color: #fff200; font-size: 11px;
    font-weight: normal;    margin-top: 5px;"
          >
            All paid features 100% Free during Covid-19 crisis
          </div>
        </td>
      </tr>
      <tr>
        <td>Number of websites you can use the plugin on</td>
        <td>Unlimited</td>
        <td>Upto 5 sites</td>
        <td>Unlimited</td>
      </tr>
      <tr :class="{ highlight: highlight_feature == 'services' }">
        <td>Number of active Event Types</td>
        <td>1 active event type</td>
        <td>Unlimited</td>
        <td>Unlimited</td>
      </tr>
      <tr>
        <td>Unlimited event scheduling by invitees</td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
      </tr>
      <tr :class="{ highlight: highlight_feature == 'wpcal_admins' }">
        <td>Number of WP admins who can create an event type</td>
        <td>1 admin per site</td>
        <td>Upto 10 admins per site</td>
        <td>Unlimited</td>
      </tr>
      <tr :class="{ highlight: highlight_feature == 'calendars' }">
        <td>Number of connected calendar accounts</td>
        <td>1 calendar account per admin</td>
        <td>Unlimited calendar accounts per admin</td>
        <td>Unlimited calendar accounts per admin</td>
      </tr>
      <tr x>
        <td>Google Calendar integration</td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
      </tr>
      <tr>
        <td>Zoom, GoToMeeting, Google Meet integrations</td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
      </tr>
      <tr :class="{ highlight: highlight_feature == 'questions' }">
        <td>Additional questions</td>
        <td>1</td>
        <td>
          Unlimited
        </td>
        <td>
          Unlimited
        </td>
      </tr>
      <tr :class="{ highlight: highlight_feature == 'email_features' }">
        <td>
          Send email notifications from your own server
        </td>
        <td></td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
      </tr>
      <tr :class="{ highlight: highlight_feature == 'email_features' }">
        <td>
          Email customization in PHP
        </td>
        <td></td>
        <td>
          <span class="check"></span>
        </td>
        <td>
          <span class="check"></span>
        </td>
      </tr>
      <tr :class="{ highlight: highlight_feature == 'branding_customization' }">
        <td>
          Brand customization
        </td>
        <td></td>
        <td>
          Pro only
        </td>
        <td>
          <span class="check"></span>
        </td>
      </tr>
    </table>

    <div style="text-align:right;">
      <a
        href="https://wpcal.io/?utm_source=wpcal_plugin&utm_medium=stronger_together_dialog#pricing"
        target="_blank"
        >See Pricing for more Premium features &nearr;</a
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    highlight_feature: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.covid-consent-cont-table-plus {
  padding: 20px;
  font-family: "Rubik";
}
.covid-consent-cont-table-plus table {
  margin: 20px 0 5px;
  border-collapse: collapse;
}
.covid-consent-cont-table-plus table tr.highlight,
.covid-consent-cont-table-plus table tr.highlight td:last-child {
  background-color: #f9f5bf;
}
.covid-consent-cont-table-plus table td {
  padding: 7px;
  border: 1px solid #d8dbe7;
  font-size: 13px;
}
.covid-consent-cont-table-plus table tr:first-child td {
  font-family: "RubikMed" !important;
}
.covid-consent-cont-table-plus table tr td:not(:first-child) {
  text-align: center;
}
.covid-consent-cont-table-plus table tr td:last-child {
  background-color: #e4e9f5;
}
.covid-consent-cont-table-plus table td .check {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9.75 7.19'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%236ab04c;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3EAsset 1%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M3,7.19a1.51,1.51,0,0,1-1.06-.44L.22,5A.75.75,0,0,1,1.28,4L3,5.69,8.47.22A.75.75,0,0,1,9.53,1.28L4.06,6.75A1.51,1.51,0,0,1,3,7.19Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  width: 16px;
  height: 12px;
  display: block;
  margin: auto;
}
</style>
